const adminStore = {
    namespaced: true,
    state: {
        selectedTreatment: null,
        selectedDate: null,
        selectedTime: null
       
    },
    mutations: {

    }
};
export default adminStore